import { render, staticRenderFns } from "./ProcedureItems.vue?vue&type=template&id=5a2c52fc&scoped=true&"
import script from "./ProcedureItems.vue?vue&type=script&lang=js&"
export * from "./ProcedureItems.vue?vue&type=script&lang=js&"
import style0 from "./ProcedureItems.vue?vue&type=style&index=0&id=5a2c52fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2c52fc",
  null
  
)

export default component.exports